import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card-body" }
const _hoisted_2 = { class: "seq-stat-card__icon" }
const _hoisted_3 = {
  key: 0,
  class: "seq-stat-card__label"
}
const _hoisted_4 = { class: "seq-stat-card__label mb-1" }
const _hoisted_5 = { class: "d-flex align-items-center mb-2" }
const _hoisted_6 = { class: "seq-stat-card__value me-2" }
const _hoisted_7 = {
  key: 0,
  class: "text-muted fs-8"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")

  return (_openBlock(), _createBlock("div", {
    class: ["card seq-card seq-stat-card h-100", { 'seq-stat-card--compact': _ctx.compact }]
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", {
        class: ["d-flex justify-content-between align-items-start", _ctx.compact ? 'mb-2' : 'mb-4']
      }, [
        _createVNode("div", _hoisted_2, [
          _createVNode("span", {
            class: ["svg-icon svg-icon-white", _ctx.compact ? 'svg-icon-3' : 'svg-icon-2']
          }, [
            _createVNode(_component_inline_svg, { src: _ctx.icon }, null, 8, ["src"])
          ], 2)
        ]),
        (_ctx.period)
          ? (_openBlock(), _createBlock("span", _hoisted_3, _toDisplayString(_ctx.period), 1))
          : _createCommentVNode("", true)
      ], 2),
      _createVNode("div", _hoisted_4, _toDisplayString(_ctx.label), 1),
      _createVNode("div", _hoisted_5, [
        _createVNode("span", _hoisted_6, _toDisplayString(_ctx.currencySymbol) + _toDisplayString(_ctx.currencySymbol ? ' ' : '') + _toDisplayString(_ctx.formattedValue), 1),
        (_ctx.trend)
          ? (_openBlock(), _createBlock("span", {
              key: 0,
              class: [_ctx.trendUp ? 'seq-trend-up' : 'seq-trend-down', "fs-8"]
            }, _toDisplayString(_ctx.trend), 3))
          : _createCommentVNode("", true)
      ]),
      (_ctx.comparison)
        ? (_openBlock(), _createBlock("div", _hoisted_7, _toDisplayString(_ctx.comparison), 1))
        : _createCommentVNode("", true)
    ])
  ], 2))
}